import React, { Component } from 'react';

class SimpleModal extends Component {
  render() {
    return (
      <div className={`modal ${this.props.show ? 'is-active' : ''}`}>
        <div className="modal-background"></div>
        <div className="modal-content">
          <div className="modal-card">
            <section className="modal-card-body">
              {this.props.content}
            </section>
          </div>
        </div>
        <button className="modal-close is-large" aria-label="close" onClick={this.props.hideImageGallery}></button>
      </div>
    )
  }
}

export default SimpleModal;


// WEBPACK FOOTER //
// ./src/app/components/simple-modal/index.js